module.exports = {
          srcSet: __webpack_public_path__ + "7ebd0877.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "7ebd0877.jpg",width: 330,height: 191}],
          src: __webpack_public_path__ + "7ebd0877.jpg",
          toString:function(){return __webpack_public_path__ + "7ebd0877.jpg"},
          
          width: 330,
          height: 191
        }